import { render } from "./DecorationLibraryArtworkDetail.vue?vue&type=template&id=43924595&scoped=true"
import script from "./DecorationLibraryArtworkDetail.vue?vue&type=script&lang=js"
export * from "./DecorationLibraryArtworkDetail.vue?vue&type=script&lang=js"

import "./DecorationLibraryArtworkDetail.vue?vue&type=style&index=0&id=43924595&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43924595"]])

export default __exports__